var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.956 1.378c-.267 0-.467.2-.467.467a.47.47 0 00.467.466c.266 0 .466-.2.466-.466 0-.267-.2-.467-.466-.467zm1.288 0c-.266 0-.466.2-.466.467 0 .266.2.466.466.466.267 0 .467-.2.467-.466 0-.267-.2-.467-.467-.467z",
    fill: "#45355C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.888 13.6a.786.786 0 001 .4c.377-.156.555-.623.4-1l-1.245-2.822 2.467.066-5.49-5.089-.044 7.49L9.665 10.8l1.223 2.8z",
    fill: "#45355C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 0H1.333C.6 0 0 .6 0 1.333v14c0 .734.6 1.334 1.333 1.334h17.334c.733 0 1.333-.6 1.333-1.334v-14C20 .6 19.4 0 18.667 0zm.446 15.334c0 .244-.2.444-.445.444H1.335a.446.446 0 01-.444-.444V3.578h18.222v11.756zm0-12.645H.89V1.333c0-.244.2-.444.444-.444h17.333c.245 0 .445.2.445.444V2.69z",
    fill: "#45355C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.533 1.378c-.266 0-.466.2-.466.467 0 .266.2.466.466.466.267 0 .467-.2.467-.466 0-.267-.2-.467-.467-.467z",
    fill: "#45355C"
  })));
}
export default SvgConfirmationPrint;